import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { Card, Table, Spinner } from "react-bootstrap";
import profilePic from "../../../assets/img/profilepic.png";
import "./profile.css";
import { useDispatch } from "react-redux";
import { uploading } from "../../../features/uploading/uploadingSlice";
import { uploadImage } from "../../../services/student";

// library for phone input
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const baseUrl = process.env.REACT_APP_API_ENDPOINT;
// toaster for error
const errorNotify = (msg) =>
  toast(msg, {
    duration: 3000,
    position: "top-right",
    style: {
      backgroundColor: "red",
      color: "white",
    },
  });

// toaster for success
const successNotify = (msg) =>
  toast(msg, {
    duration: 3000,
    position: "top-right",
    style: {
      backgroundColor: "green",
      color: "white",
      marginTop: "50px",
    },
  });
// loader
const Loader = () => {
  return (
    <div className="text-center">
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className="text">
      {isReadMore ? text?.slice(0, 600) : text}
      <span onClick={toggleReadMore} className="read-or-hide">
        {isReadMore ? "...read more" : " show less"}
      </span>
    </p>
  );
};

function Profile(props) {
  const dispatch = useDispatch();
  // state for form is editable or not
  const [editform, setEditForm] = useState(false);
  // loader state
  const [loader, setLoader] = useState();
  // state to store userdata from response
  const [user, setUser] = useState();

  // get country list for drop down
  const [countries, setCountries] = useState([]);
  useEffect(() => {
    async function fetchData() {
      const url = baseUrl + `/countries?per_page=258`;
      const headers = {
        Accept: "application/json",
      };
      await axios
        .get(url, { headers })
        .then((response) => {
          setCountries(response.data.data);
        })
        .catch((error) => {
          let err;
          err = "Something went wrong";
          errorNotify(err);
        });
    }
    fetchData();
  }, []);

  // get language list for languaege dropddown
  const [languages, setLanguages] = useState([]);
  useEffect(() => {
    async function fetchData() {
      const url = baseUrl + `/languages?per_page=131`;
      const headers = {
        Accept: "application/json",
      };
      await axios
        .get(url, { headers })
        .then((response) => {
          setLanguages(response.data.data);
        })
        .catch((error) => {
          let err;
          err = "Something went wrong";
          errorNotify(err);
        });
    }
    fetchData();
  }, []);

  // handle edit
  const handleEdit = (event) => {
    event.preventDefault();
    setEditForm(!editform);
  };
  // get token from local storage and hit aPI to get user data
  useEffect(() => {
    async function fetchData() {
      setLoader(true);
      const url = baseUrl + `/student/profile`;
      const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
      };
      await axios
        .get(url, { headers })
        .then((response) => {
          setUser(response.data.data);
          setLoader(false);
        })
        .catch((error) => {
          let err;
          if (error.response.status === 422) {
            err = Object.values(error.response.data.errors)[0][0];
          } else if (error.response.status === 400) {
            err = error.response.data.message;
          } else if (error.response.status === 401) {
            err = error.response.data.message;
          } else {
            err = "Something went wrong";
          }
          errorNotify(err);
        });
    }
    fetchData();
  }, [editform]);

  // handle profile upload
  const [imgData, setImgData] = useState(null);
  const [image_id, setImage_id] = useState();
  const handleUpload = async (event) => {
    // to get priewv of the image yet to be uploaded
    if (event.target.files[0]) {
      // dispatch(Uploading(true));
      dispatch(uploading(true));
      // uploading image
      const formData = new FormData();
      formData.append("image", event.target.files[0]);
      await uploadImage(formData, props.setPercentage)
        .then((response) => {
          // setting image id from response
          setImage_id(response.data.data.id);
        })
        .catch((error) => errorNotify("Something went wrong"));
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgData(reader.result);
      });
      reader.readAsDataURL(event.target.files[0]);
    }
    // dispatch(Uploading(false))
    dispatch(uploading(false));
  };

  // handle form input chnage
  // state to show required error
  const [errors, setErrors] = useState({
    bio: false,
    first_name: false,
    last_name: false,
    city: false,
    state: false,
    phone: false,
    validForm: true,
  });
  const handleChange = (event) => {
    const { name, value } = event.target;
    setUser({
      ...user,
      [name]: value,
    });
    if (value.length === 0) {
      setErrors({
        ...errors,
        [name]: true,
        validForm: false,
      });
    } else {
      setErrors({
        ...errors,
        [name]: false,
        validForm: true,
      });
    }
  };
  // handle form submit
  const onSubmit = async (event) => {
    event.preventDefault();
    // create object of the form which needs to be submit
    const obj = {
      bio: user.bio,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      city: user.city,
      state: user.state,
      country_id: user.country_id,
      phone: user.phone,
      language: user.language,
      profile_image_id: image_id ? image_id : user.profile_image_id,
    };
    const url = baseUrl + "/student/profile";
    const headers = {
      Accept: "application/json",
      Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
    };
    await axios
      .post(url, obj, { headers })
      .then((response) => {
        setEditForm(false);
        successNotify("Updated Successfully");
      })
      .catch((error) => {
        errorNotify("Something went wrong");
      });
  };

  return (
    <>
      <main id="main" className="bg-inner">
        <section className="student-signup-page signup-congrats">
          <div className="container">
            {loader ? (
              <Loader />
            ) : (
              <form>
                <div className="row p-2">
                  <div className="col-sm-6">
                    <Card className="left-card mb-2 mt-5">
                      <div
                        className={`${
                          editform ? "edit_profile_icon" : "display_none"
                        }`}
                      >
                        <label>
                          <i className="bi bi-pencil-square">
                            <input type="file" onChange={handleUpload} />
                          </i>
                        </label>
                      </div>
                      <Card.Img
                        variant="center"
                        src={
                          imgData
                            ? imgData
                            : user?.image
                            ? `https://daylearningapi.daydevelopers.com/storage/${user.image.path}`
                            : profilePic
                        }
                        height={150}
                        width={150}
                        alt="profile_image"
                        className="profile_pic rounded-circle mt-4 m-auto"
                      />
                      <Card.Body className="mt-2">
                        <Card.Title className="font-weight-bold">
                          Bio
                        </Card.Title>
                        <Card.Text>
                          {editform ? (
                            <textarea
                              className="form-control input_fields"
                              rows="12"
                              disabled={!editform}
                              defaultValue={user?.bio}
                              name="bio"
                              onChange={handleChange}
                            ></textarea>
                          ) : user?.bio ? (
                            <ReadMore>{user?.bio}</ReadMore>
                          ) : (
                            ""
                          )}

                          {errors.bio ? (
                            <span className="text-danger">Required</span>
                          ) : null}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="col-sm-6 p-2 mt-5">
                    <Table hover>
                      {/* switch to input fields if updateding profile */}
                      {editform ? (
                        <tbody>
                          <tr>
                            <td>First Name</td>
                            <td>
                              <input
                                type="text"
                                className="form-control input_fields"
                                disabled={!editform}
                                defaultValue={user?.first_name}
                                name="first_name"
                                onChange={handleChange}
                              />
                              {errors.first_name ? (
                                <span className="text-danger">Required</span>
                              ) : null}
                            </td>
                          </tr>
                          <tr>
                            <td>Last Name</td>
                            <td>
                              <input
                                type="text"
                                className="form-control input_fields"
                                disabled={!editform}
                                defaultValue={user?.last_name}
                                name="last_name"
                                onChange={handleChange}
                              />
                              {errors.last_name ? (
                                <span className="text-danger">Required</span>
                              ) : null}
                            </td>
                          </tr>
                          <tr>
                            <td>Email</td>
                            <td>
                              <input
                                type="text"
                                className="form-control input_fields"
                                disabled
                                value={user?.email}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>City</td>
                            <td>
                              <input
                                type="text"
                                className="form-control input_fields"
                                disabled={!editform}
                                defaultValue={user?.city}
                                name="city"
                                onChange={handleChange}
                              />
                              {errors.city ? (
                                <span className="text-danger">Required</span>
                              ) : null}
                            </td>
                          </tr>
                          <tr>
                            <td>State</td>
                            <td>
                              <input
                                type="text"
                                className="form-control input_fields"
                                disabled={!editform}
                                defaultValue={user?.state}
                                name="state"
                                onChange={handleChange}
                              />
                              {errors.state ? (
                                <span className="text-danger">Required</span>
                              ) : null}
                            </td>
                          </tr>
                          <tr>
                            <td>Country</td>
                            <td>
                              <select
                                disabled={!editform}
                                className="form-control input_fields"
                                name="country_id"
                                onChange={handleChange}
                              >
                                <option value={user?.country?.id} selected>
                                  {user?.country?.name}
                                </option>
                                {countries.map((item) => {
                                  return (
                                    <option key={item?.id} value={item?.id}>
                                      {item?.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Phone</td>
                            <td>
                              <PhoneInput
                                value={user?.phone}
                                country={"us"}
                                disabled={!editform}
                                onChange={(e) => {
                                  setUser({
                                    ...user,
                                    phone: e,
                                  });
                                  if (e.length === 0) {
                                    setErrors({
                                      ...errors,
                                      phone: true,
                                      validForm: false,
                                    });
                                  } else {
                                    setErrors({
                                      ...errors,
                                      phone: false,
                                      validForm: true,
                                    });
                                  }
                                }}
                              />
                              {errors.phone ? (
                                <span className="text-danger">Required</span>
                              ) : null}
                            </td>
                          </tr>
                          <tr>
                            <td>Language</td>
                            <td>
                              <select
                                disabled={!editform}
                                className="form-control input_fields"
                                name="language"
                                onChange={handleChange}
                              >
                                <option value={user?.language} selected>
                                  {user?.language}
                                </option>
                                {languages.map((item) => {
                                  return (
                                    <option key={item.id} value={item.name}>
                                      {item.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        // table to show when not updating editing
                        <tbody>
                          <tr>
                            <td>First Name</td>
                            <td>{user?.first_name}</td>
                          </tr>
                          <tr>
                            <td>Last Name</td>
                            <td>{user?.last_name}</td>
                          </tr>
                          <tr>
                            <td>Email</td>
                            <td>{user?.email}</td>
                          </tr>
                          <tr>
                            <td>City</td>
                            <td>{user?.city}</td>
                          </tr>
                          <tr>
                            <td>State</td>
                            <td>{user?.state}</td>
                          </tr>
                          <tr>
                            <td>Country</td>
                            <td>{user?.country?.name}</td>
                          </tr>
                          <tr>
                            <td>Phone</td>
                            <td>{user?.phone}</td>
                          </tr>
                          <tr>
                            <td>Language</td>
                            <td>{user?.language}</td>
                          </tr>
                        </tbody>
                      )}
                    </Table>
                    <div className="row">
                      <div className="col-sm-12">
                        {editform ? (
                          <button
                            type="submit"
                            onClick={onSubmit}
                            disabled={!errors.validForm}
                            className="form-control btn btn-primary edit-btn"
                          >
                            Update Profile
                          </button>
                        ) : (
                          <button
                            className="form-control btn btn-primary edit-btn"
                            onClick={handleEdit}
                          >
                            Edit Profile
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </div>
        </section>
      </main>
      <Toaster />
    </>
  );
}

export default Profile;
